<template>
<v-card height='100%' >
  <v-system-bar >
    <v-chip class="v-chip--x-small" flat @click="$router.push({path:'/invoices'})" >
      <v-icon small left >chevron_left</v-icon>
      Return to invoices
    </v-chip>
  </v-system-bar>
  <v-toolbar dense extended flat >
    <v-btn icon small
      @click="get"
      :loading="requests.get.loading" ><v-icon small >replay</v-icon></v-btn>
    <v-toolbar-title class="mr-3" >Payments</v-toolbar-title>
    <v-btn small outline color="info" @click="launchDateRangePicker"  >
      <v-icon small class="mr-2" >event</v-icon>
    {{ globalActiveDateRangeFormatted }}
    </v-btn>
    <v-spacer />
    <!-- <date-range-picker v-model="activeDateRange" /> -->
    <v-text-field
      v-model="search"
      @click:append="doSearch"
      @keyup.enter="doSearch"
      @keyup.esc="clearSearch"
      placeholder="Search"
      type="Search"
      hint="Search on reference, or amount"
      append-icon="search" />
    <v-checkbox
      v-model="searchwithdaterange"
      label="within date range" class="mt-3 ml-2 mr-0" />
    <template slot="extension" >
      {{ numTransactions }} payments found
      <v-chip close
        @input="clearSearch"
        class="v-chip--x-small ml-2" v-if="activesearch" >{{ activesearch }}</v-chip>
      <v-spacer/>
      <template v-if="numPages && numPages > 0" >
        <v-btn :disabled="page<=1" @click="page--" icon small ><v-icon>chevron_left</v-icon></v-btn>
        Page {{ page }} of {{ numPages }}
        <v-btn :disabled="page>=numPages" @click="page++" icon small ><v-icon>chevron_right</v-icon></v-btn>
      </template>
    </template>
  </v-toolbar>
  <v-divider/>
  <request-status :request="requests.get" :message200="false" />

  <v-card-text >
    <v-list >
      <template v-for="payment in transactions" >
        <payment-list-item
          :item="payment"
          :key="payment.id" />
        <v-divider :key="`div-${payment.id}`" />
      </template>
    </v-list>
  </v-card-text>

  <v-card-actions >
    <v-spacer />
    <v-btn :disabled="page<=1" @click="page--" icon small ><v-icon>chevron_left</v-icon></v-btn>
    <v-btn :disabled="page>=numPages" @click="page++" icon small ><v-icon>chevron_right</v-icon></v-btn>
  </v-card-actions>

</v-card>
</template>

<script>
// import {LIST_TRANSACTIONS_IN_RANGE_REQ} from '@/store/constants'
// import AgDataDisplay from '@/components/ui/AgDataDisplay'
import DateRangePicker from '@/components/pickers/DateRangePicker'
import PaymentListItem from '../../listitems/PaymentListItem.vue'
// const ALLOW_UNASSIGN = false
// const INITIAL_PAGE_SIZE = 100
// import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  name: 'TransactionsTable',
  components: {PaymentListItem, DateRangePicker},
  props: {
    loading: {type: Boolean, default: false}
  },
  data () {
    return {
      search: '',
      page: 1,
      pageSize: 20,
      searchwithdaterange: true,
      activesearch: null,
      requests: {
        get: {
          resource: 'invoiceguru.transactions',
          params: {
            type: 'Payment'
          }
        }
      }
    }
  },
  mounted () {
    this.get()
  },
  watch: {
    globalActiveDateRangeFormatted () {
      this.get()
    },
    page () {
      this.get()
    },
    searchwithdaterange () {
      this.doSearch()
    }
  },
  computed: {
    ...mapGetters(['activeDateRange']),
    transactions () { return this.getObjectPath(this.requests.get, 'result.results', []) },
    numTransactions () {
      return this.getObjectPath(this.requests.get, 'result.count', 0)
    },
    numPages () {
      if (this.pageSize === 0) { return 0 }
      return Math.ceil(this.numTransactions / this.pageSize)
    }
  },
  methods: {
    applyFilters () {
      let params = {
        page_size: this.pageSize,
        page: this.page
      }
      if (this.activeDateRange.from) {
        params['after_utc'] = this.activeDateRange.from
      }
      if (this.activeDateRange.to) {
        params['before_utc'] = this.activeDateRange.to
      }
      this.requests.get.params = params
    },
    clearSearch () {
      this.activesearch = ''
      this.get()
    },
    doSearch () {
      this.page = 1
      let params = {
        page_size: this.pageSize,
        page: this.page
      }
      if (this.searchwithdaterange) {
        if (this.activeDateRange.from) {
          params['after_utc'] = this.activeDateRange.from
        }
        if (this.activeDateRange.to) {
          params['before_utc'] = this.activeDateRange.to
        }
      }
      params['search'] = this.search
      this.activesearch = this.search
      this.requests.get.params = params
      this.$request('get', this.requests.get)
    },
    get () {
      this.applyFilters()
      this.$request('get', this.requests.get)
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Payments'
      }
    }
  }
}
</script>

<style scoped >
.Payment {
  background-color: #C8E6C9;
}
.fixed-width {
  min-width:150px;
}

</style>



// WEBPACK FOOTER //
// Transactions.vue?d4a0c6a6